export default "__VITE_ASSET__CiXTCRU8__"